import { Loader } from '@/utils/Loader'
import { CubeTextureLoader } from 'three'

export class BallAssets {
  constructor () {
    this.promises = []
    this.promises.push(Loader.load('/objects/sphere--01.glb').then(obj => {
      this.baseSphere = obj.getObjectByName('Sphere')
    }))
    this.promises.push(this.loadEnvMap().then(texture => {
      this.envMap = texture
    }))

    this.promise = Promise.all(this.promises)
  }

  loadEnvMap () {
    return new Promise( (resolve, reject) => {
      const path = "/images/cubemap/"
      const format = '.png'
      const urls = [
        path + 'px' + format, path + 'nx' + format,
        path + 'py' + format, path + 'ny' + format,
        path + 'pz' + format, path + 'nz' + format
      ]

      const textureCube = new CubeTextureLoader().load( urls, resolve )
    })
  }
}

export const ballAssets = new BallAssets()